// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a0b435d","455":"12841563"}[chunkId] + ".chunk.js";
};